import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { ImMail2 } from 'react-icons/im';
import { Navigation } from '../navigation/navigation';
import { breakpoints, colors, fonts } from '../styles/theme';

const Footer = styled.footer`
  background: ${colors.accentDeep};
  color: ${colors.cream};
  padding: 56px 24px 40px;
  text-align: center;
`;

const FooterName = styled.div`
  font-family: ${fonts.display};
  font-size: 24px;
  letter-spacing: 0.12em;
  margin-bottom: 18px;
`;

const FooterRule = styled.div`
  width: 56px;
  height: 1px;
  background: ${colors.gold};
  margin: 0 auto 22px;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px 30px;
`;

const FooterLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: ${colors.cream};
  text-decoration: none;
  font-size: 14px;
  letter-spacing: 0.04em;
  opacity: 0.85;
  transition: opacity 0.2s ease, color 0.2s ease;

  svg {
    color: ${colors.gold};
  }

  &:hover {
    opacity: 1;
    color: ${colors.goldLight};
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
  }
`;

export function RootLayout() {
  return (
    <>
      <Navigation />
      <Outlet />
      <Footer>
        <FooterName>BIRGITTA BJÖRG</FooterName>
        <FooterRule />
        <FooterLinks>
          <FooterLink href="mailto:birgittabjorg98@gmail.com">
            <ImMail2 fontSize={16} />
            birgittabjorg98@gmail.com
          </FooterLink>
          <FooterLink href="https://facebook.com">
            <FontAwesomeIcon fontSize={16} icon={faFacebook} />
            Birgitta Björg Guðmarsdóttir
          </FooterLink>
          <FooterLink href="https://instagram.com">
            <FontAwesomeIcon fontSize={16} icon={faInstagram} />
            @stjornuljosa
          </FooterLink>
        </FooterLinks>
      </Footer>
    </>
  );
}
